<template>
    <div class="content-container">
        <div class="content-container-header">
            <WidgetToolbar title="School Partner" :icon="require('@/assets/admin-icon/menu/school_active.svg')">
                <div class="options">
                    <widgetSelect style="width: 150px;" :opt="schools" placeholder="Select school"
                        @input="onSelectClass"></widgetSelect>
                </div>
            </WidgetToolbar>
        </div>
        <div class="content-container-body">
            <div class="student-list-report">
                <div class="page-wrapper" v-if="selected_school">
                    <SkillsChart v-if="active_page == 'general'" :school="selected_school"
                        @ViewConsultantsProfiles="showConsultantsProfiles">
                    </SkillsChart>
                    <SkillsCompare :school="selected_school" v-if="active_page == 'compare'"></SkillsCompare>
                    <ConsultantsProfiles v-if="active_page == 'profiles'" :form="formFilter"
                        @back="active_page = 'general'">
                    </ConsultantsProfiles>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
import SkillsChart from "./components/skillsChart.vue";
import ConsultantsProfiles from "./components/ConsultantsProfiles.vue";
import SkillsCompare from "./components/skillsCompare.vue";

export default {
    components: {
        SkillsChart,
        ConsultantsProfiles,
        SkillsCompare
    },
    props: {

    },
    data: () => ({
        activeTab: 1,
        active_page: 'general',
        formFilter: null,
        schools: [],
        selected_school: null

    }),
    mounted() {
        let vm = this;
        vm.getCompanyConnectedSchools();
    },
    computed: {
    },
    methods: {
        onSelectClass(id) {
            this.selected_school = {
                id: id
            };
        },
        getCompanyConnectedSchools() {
            let vm = this;
            vm.$store.dispatch("COMPANY_GET_CONNECTED_SCHOOLS").then((response) => {
                vm.schools = response.data.map((item) => {
                    return { label: item.name, value: item.id }
                });
                if (vm.schools.length > 0) {
                    vm.selected_school = {
                        id: vm.schools[0].value
                    };
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        switchTab(tab) {
            let vm = this;
            vm.active_page = tab.value;
        },
        showConsultantsProfiles(form) {
            let vm = this;
            vm.formFilter = form;
            vm.active_page = "profiles"
        },
        backToSkills() {
            let vm = this;
            vm.formFilter = null;
            vm.active_page = "general"
        }
    },
};
</script>

<style lang="scss" scoped>
.content-container {
    height: 100%;
    width: calc(100% - 193px);
    display: flex;
    flex-direction: column;
    padding: 5px;
    background-color: #eeeeee;

    .content-container-header {
        height: 50px;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
    }

    .content-container-body {
        height: calc(100% - 60px);
        display: flex;

        .student-list-report {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;

            .page-wrapper {
                display: flex;
                flex-direction: column;
                height: 100%;
                background: #ebebeb;

            }
        }
    }
}
</style>